<template>
  <v-autocomplete
    v-on="$listeners"
    v-bind="[defaultConfigs]"
    :items="items"
    :loading="loading"
    hide-details
    hide-selected
    clearable
    append-inner=""
    class="base-autocomplete"
    outlined
    dense
    item-text="name"
    item-value="id"
    :return-object="true"
    multiple
    @change="resetFilter"
    :search-input.sync="filter"
  />
</template>
<script lang="ts">
const defaultProp = {
  outlined: true,
  class: "mt-2 caption",
  dense: true,
  "background-color": "white",
};
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../../mixins/ActionMixin";
import { Action } from "vuex-class";
import { Prop } from "vue-property-decorator";
@Component
export default class BaseAutocompleteEvent extends mixins(ActionMixin) {
  @Action("profile/requestAllEvents") requestAllEvents: any;
  @Prop({ default: [] }) events: Array<Event>;
  items: any[] = [];
  loading = false;
  filter = "";
  get defaultConfigs(): any {
    return {
      ...this.$attrs,
      ...this.$props,
      ...defaultProp,
    };
  }
  created(): void {
    this.updateMentionList();
  }
  async updateMentionList(): Promise<void> {
    this.loading = true;
    if (this.events.length === 0) {
      await this.withLoading(async () => {
        await this.requestAllEvents()
          .then((data: any) => {
            this.items = data;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    } else {
      this.items = this.events;
      this.loading = false;
    }
  }
  resetFilter(): void {
    this.filter = "";
  }
}
</script>
<style lang="sass">
.v-text-field--outlined.base-autocomplete fieldset, .v-text-field.base-autocomplete .v-input__control .v-input__slot
  border: none
.base-autocomplete
  .v-text-field__details
    display: none !important
  .v-input__append-inner
    display: none !important
  .v-label--active
    display: none !important
  .v-input__slot
    padding: 0 8px !important
  &__chip
    border-radius: 5px !important
</style>
